<template>
  <AllRecordsTable
    :submit-button-text="table.submitButtonText"
    :table-name="contactType"
    :link-slug="contactType"
    :title="table.title"
    :columns="table.columnNames"
    :order-fields="orderFields"
    :filter-fields="table.filterFields"
    :rows="table.rowNames"
  />
</template>

<script>
import AllRecordsTable from "@/_shared/widgets/AllRecordsTable";
import { lists } from "@/business/constants";
import { arrayHelper } from "@/_shared/utils";
export default {
  components: {
    AllRecordsTable,
  },
  computed: {
    orderFields() {
      const { columnNames, rowNames } = this.table;
      return arrayHelper.combine(columnNames, rowNames);
    },
    table() {
      return lists[this.contactType];
    },
    contactType() {
      return this.$route.fullPath.substring(1);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/business/pages/AllBusinessContactsPage.vue